<template>
  <div style="text-align: left">
    <el-form ref="form" :model="form" label-width="100px">
      <el-form-item>
        <el-row>
          <el-col :span="2">支付者编号</el-col>
          <el-col :span="4">
            <el-input v-model="form.payerId" placeholder="请输入支付者编号" clearable>
            </el-input>
          </el-col>
          <el-col :span="2" :offset="1">推荐者编号</el-col>
          <el-col :span="4">
            <el-input v-model="form.recommenderId" placeholder="请输入推荐者编号" clearable>
            </el-input>
          </el-col>
          <el-col :span="2" :offset="1">状态</el-col>
          <el-col :span="4">
            <el-select v-model="form.status" placeholder="请选择">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="待处理" :value="0"></el-option>
              <el-option label="待返现" :value="1"></el-option>
              <el-option label="已返现" :value="2"></el-option>
            </el-select>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item>
        <el-row>
          <el-col :offset="18" :span="2">
            <el-button type="primary" @click="onQuery"><i class="el-icon-search"></i> 查询</el-button>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>

    <el-table
      :data="cashbackList"
      border
      style="width: 100%">
      <el-table-column
        prop="id"
        label="编号">
      </el-table-column>
      <el-table-column
        prop="payerId"
        label="支付者编号">
        <template slot-scope="scope">
          <router-link v-if="scope.row.payerId" :to="{path: '/user/details', query: {id: scope.row.payerId}}">{{scope.row.payerId}}</router-link>
          <span v-else>#</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="recommenderId"
        label="推荐者编号">
        <template slot-scope="scope">
          <router-link v-if="scope.row.recommenderId" :to="{path: '/user/details', query: {id: scope.row.recommenderId}}">{{scope.row.recommenderId}}</router-link>
          <span v-else>#</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="payId"
        label="支付记录编号">
      </el-table-column>
      <el-table-column
        prop="amount"
        label="金额">
        <template slot-scope="scope">
          {{ scope.row.amount / 100 }} 元
        </template>
      </el-table-column>
      <el-table-column
        prop="payTime"
        label="支付时间">
        <template slot-scope="scope">
          {{ scope.row.payTime ? scope.row.payTime.substring(0, 19) : '' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="payType"
        label="支付类型">
        <template slot-scope="scope">
          <el-tag
            :type="getPayTypeTag(scope.row.payType)"
            disable-transitions>{{getPayTypeText(scope.row.payType)}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态">
        <template slot-scope="scope">
          <el-tag
            :type="getStatusTag(scope.row.status)"
            disable-transitions>{{getStatusText(scope.row.status)}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注">
      </el-table-column>
    </el-table>

    <el-pagination
      class="pagination"
      background
      layout="total, sizes, prev, pager, next"
      @size-change="handleSizeChange"
      @current-change="handlePageChange"
      :current-page.sync="form.page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="form.size"
      :total="totalElements">
    </el-pagination>
  </div>

</template>

<script>
import * as api from "@/js/api.js";

export default {
  name: "CashBackList",
  data() {
    return {
      form: {
        payerId: undefined,
        recommenderId: undefined,
        status: undefined,
        page: 1,
        size: 20
      },
      cashbackList: [],
      totalElements: 0,
    }
  },
  methods: {
    handlePageChange() {
      this.onQuery()
    },
    handleSizeChange(val) {
      this.form.size = val
      this.onQuery()
    },
    onQuery() {
      this.form.page = 1
      const query = {}
      if (this.form.payerId) query.payerId = this.form.payerId
      if (this.form.recommenderId) query.recommenderId = this.form.recommenderId
      if (this.form.status !== undefined) query.status = this.form.status
      query.page = this.form.page
      query.size = this.form.size

      api.cashbackQuery(query).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('查询返现记录出错');
        } else {
          this.cashbackList = result.data.content
          this.totalElements = result.data.totalElements
        }
      })
    },
    getStatusText(status) {
      const map = {
        0: '待处理',
        1: '待返现',
        2: '已返现'
      }
      return map[status] || '未知'
    },
    getStatusTag(status) {
      const map = {
        0: 'warning',
        1: 'primary',
        2: 'success'
      }
      return map[status] || 'info'
    },
    getPayTypeText(payType) {
      const map = {
        1: '399套餐',
        2: '499套餐',
        3: '599套餐',
        4: '升级套餐',
        5: '购买商品',
        10: '用户保养',
        11: '其它服务',
        20: '修理厂入驻',
        21: '城市合伙人',
        22: '省代入驻',
        23: '运营中心',
        30: '检测站消费',
        31: '检测站入驻'
      }
      return map[payType] || '未知'
    },
    getPayTypeTag() {
      return 'primary'
    }
  },
  mounted() {
    this.onQuery()
  },
}
</script>

<style scoped>
.pagination {
  margin-top: 15px;
}
</style>


// WEBPACK FOOTER //
// src/pages/cashback/CashBackList.vue